import tw, { theme } from 'twin.macro';
import styled from '@emotion/styled';

import { PageMode } from '$/components/ui/Input/PageBuilder.types';

const getStartOrEndMarkerTitle = ({ text }: StartOrEndMarkerProps): string => {
  if (text.length < 40) return CSS.escape(text);
  return CSS.escape(text.substring(0, 40).trimEnd() + '...');
};

interface StartOrEndMarkerProps {
  text: string;
  color?: string;
  mode?: PageMode;
}

export const StartOrEndMarker = styled.div<StartOrEndMarkerProps>`
  ${tw`font-body`};
  position: relative;
  z-index: 1;
  width: 100%;
  margin: 2rem 0;
  height: 1px;
  &::before {
    ${tw`
      absolute
      border
      border-solid
    `}
    border-color: ${(props): string => props.color ?? theme`colors.gray.6`.toString()};
    content: '';
    width: 100%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &::after {
    ${tw`
      absolute
      inset-auto
      border
      border-solid
      bg-white
      text-center
      text-sm
      z-10
      rounded-full
    `}
    border-color: ${(props): string => props.color ?? theme`colors.gray.6`.toString()};
    color: ${(props): string => props.color ?? theme`colors.gray.4`.toString()};
    content: '${getStartOrEndMarkerTitle}';
    min-width: 70px;
    width: ${(props): string => (props.text.length > 15 ? '90%' : 'fit-content')};
    left: 50%;
    padding: 0.25rem 15px;
    transform: translate(-50%, -50%);
  }
`;
